module.exports = __webpack_public_path__ + "img/102.798e45a1.jpg";